import { useState } from 'react'
import dynamic from 'next/dynamic'
import { Space, Menu, Affix } from 'antd'
import { useStoreActions, useStoreState } from 'easy-peasy'

import Image from 'components/Image'
import Dropdown from 'components/Dropdown'
import Icon from 'components/Icon'
import Button from 'components/Button'
import Link from 'components/Link'
import Paragraph from 'components/Paragraph'

import { mergeFullName } from 'utils'
import { useMobileDetect } from 'hooks/mobileDetect'

import Styled from './styled'

const logoImage = '/assets/images/logo-black.svg'

const DrawerMenu = dynamic(() => import('components/Drawer/DrawerMenu'), { ssr: false })
const ModalCheckLocation = dynamic(() => import('components/Modal/ModalCheckLocation'), {
  ssr: false,
})

export default function Header() {
  const isChecked = useStoreState(state => state.auth.isChecked)
  const isLogin = useStoreState(state => state.auth.isLogin)
  const profile = useStoreState(state => state.auth.profile)

  const setOpenLoginModal = useStoreActions(actions => actions.auth.setOpenLoginModal)
  const logout = useStoreActions(actions => actions.auth.logout)

  const [visibleDrawerMenu, setVisibleDrawerMenu] = useState(false)
  // const [visibleDrawerSearch, setVisibleDrawerSearch] = useState(false)
  const [openModalLocation, setOpenModalLocation] = useState(false)

  const { isTablet } = useMobileDetect()

  const profileMenu = (
    <Menu>
      <Menu.Item>
        <Link href="/my-booking">My Booking</Link>
      </Menu.Item>
      <Menu.Item onClick={() => logout()}>ออกจากระบบ</Menu.Item>
    </Menu>
  )

  let userName = profile?.username
  if (profile?.name) {
    userName = mergeFullName(profile?.name, profile?.surname)
  }

  return (
    <Styled className="header-component">
      <Affix>
        <div>
          <header className="desktop">
            <div className="header-content">
              <div className="left-block">
                <Space size={25}>
                  <Link href="/">
                    <Image
                      src={logoImage}
                      alt="24 FIX"
                      width={115}
                      height={49}
                      className="logo-image"
                    />
                  </Link>
                </Space>
              </div>

              <div className="right-block">
                <Space size={20}>
                  <Space size={20}>
                    {/* <Link href="/my-booking">
                      <Paragraph>จัดการงานซ่อม</Paragraph>
                    </Link> */}
                    <Link href="https://24x.co.th/th/home" openNewTab>
                      <Paragraph>เข้าสู่เว็บไซต์หลัก</Paragraph>
                    </Link>
                    <Link href="https://business.24x.co.th/th" openNewTab>
                      <Paragraph>บริการภาคธุรกิจ</Paragraph>
                    </Link>
                    {/* <Link href="/fixer/register" openNewTab>
                      <Paragraph>มาเป็นช่างกับเรา</Paragraph>
                    </Link> */}
                  </Space>

                  <Space size={10}>
                    <div
                      className="current-location-block"
                      onClick={() => setOpenModalLocation(true)}
                    >
                      <div className="icon-marker">
                        <Icon.Marker />
                      </div>
                      <div className="current-location-name">
                        <Paragraph>พื้นที่ให้บริการ</Paragraph>
                      </div>
                    </div>

                    {isChecked && (
                      <>
                        {isLogin ? (
                          <Dropdown overlay={profileMenu}>
                            <div className="profile-block">
                              <div className="icon-user">
                                <Icon.User />
                              </div>
                              <div className="profile-name">
                                <div className="text-name">
                                  <Paragraph ellipsis={{ rows: 1 }}>{userName}</Paragraph>
                                </div>
                                <Icon.ArrowDown className="icon-arrow-down" />
                              </div>
                            </div>
                          </Dropdown>
                        ) : (
                          <Button onClick={() => setOpenLoginModal(true)}>เข้าสู่ระบบ</Button>
                        )}
                      </>
                    )}
                  </Space>
                </Space>
              </div>
            </div>
          </header>

          <header className="mobile">
            <div className="container">
              <div className="header-content">
                <div className="left-block">
                  <div className="icon-block" onClick={() => setVisibleDrawerMenu(true)}>
                    <Icon.MenuBar style={{ fontSize: 20 }} />
                  </div>
                </div>
                <div className="center-block">
                  <Link href="/">
                    <Image
                      src={logoImage}
                      alt="24 FIX"
                      width={75}
                      height={32}
                      className="logo-image"
                    />
                  </Link>
                </div>
                <div className="right-block">
                  {/* <div className="icon-block" onClick={() => setVisibleDrawerSearch(true)}>
                    <Icon.Search style={{ fontSize: 20, color: theme.primaryRed }} />
                  </div> */}
                </div>
              </div>
            </div>
          </header>
        </div>
      </Affix>

      {isTablet && (
        <DrawerMenu visible={visibleDrawerMenu} onClose={() => setVisibleDrawerMenu(false)} />
      )}

      <ModalCheckLocation
        width={700}
        visible={openModalLocation}
        onCancel={() => setOpenModalLocation(false)}
      />
    </Styled>
  )
}
